import { Account } from './account';
import { Course } from './course';

export class Stream {
    id: number;
    name: string;
    users: Account[];
    courses: Course[];
    published: boolean;
    created_at:string;
    updated_at: string;
    price: number;
    vimeo_id: number;
    description: string;
    deleted: boolean;
    featured_order:number;
    categories:any=[];
    supporters:any=[];
    discount:any=[];
    tags:any;
    user_roles:any;
    constructor(stream?) {
        if (stream) {
            this.id = stream.id;
            this.name = stream.name;
            this.users = stream.users;
            this.courses = stream.courses;
            this.published = stream.published || false;
            this.created_at = stream.created_at;
            this.updated_at = stream.updated_at;
            this.price = stream.price || 0.00;
            this.vimeo_id = stream.vimeo_id;
            this.description = stream.description || '';
            this.deleted = stream.deleted;
            this.featured_order = stream.featured_order;
            this.categories=stream.category;
            this.supporters=stream.supporter;
            this.discount=stream.discount;
            this.tags=stream.tags;
            this.user_roles=stream.user_roles;
        }
    }
}
